export default function canCurrentUserManageProject(currentUser, project) {
  //console.log('canCurrentUserManageProject project = ', project)
  var projectTeamId = project.teamId;
  var user = currentUser.user;
  //console.log('user', user);
  var teams = user.teams;
  if (!teams) {
    //console.log('the currentUser has no teams?????????')
    return false;
  }
  //console.log('teams = ', teams);
  for (let i = 0, len = teams.length; i < len; i++) {
    var team = teams.at(i);
    if (team.id == projectTeamId) {
      var roles = team.currentUserRoles; // || [];
      //console.log('roles = ', roles);
      return roles.indexOf('admin') >= 0;
    }
  }
  return false;
}
